import { render, staticRenderFns } from "./createWrittenOffOrder.vue?vue&type=template&id=08a2afef&scoped=true"
import script from "./createWrittenOffOrder.vue?vue&type=script&lang=js"
export * from "./createWrittenOffOrder.vue?vue&type=script&lang=js"
import style0 from "./createWrittenOffOrder.vue?vue&type=style&index=0&id=08a2afef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a2afef",
  null
  
)

export default component.exports